export const formatAddress = (address?: string, number?: number, tailNumber: number = -4): string => {
  const num = number || 7;

  if (!address) {
    return "";
  }

  if (address.length < 10) {
    return address;
  }

  return `${address?.slice(0, num)}...${address?.slice(tailNumber)}`;
};

/**
 * 将字符串中间部分省略，只保留前后指定长度的部分
 * @param str - 需要处理的字符串
 * @param frontLen - 保留的前部分长度
 * @param endLen - 保留的后部分长度
 * @returns 处理后的字符串
 */
export function ellipsisMiddle(
  str?: string,
  frontLen?: number,
  endLen?: number,
): string {
  const frontLength = frontLen || 5;
  const endLength = endLen || 4;
  if (!str) {
    return "";
  }
  if (str.length <= frontLength + endLength) {
    return str;
  }
  return `${str.slice(0, frontLength)}...${str.slice(-endLength)}`;
}
